import { ThemeName } from '~/types'
import { CHANGE_THEME, changeTheme } from './actions'

export type ThemeState = ThemeName
type Action = ReturnType<typeof changeTheme> | { type: 'OTHER_ACTION'; payload?: any }

const initialState: ThemeState = 'light'

export * from './actions'
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (previousState = initialState, action: Action): ThemeState => {
  if (action.type === CHANGE_THEME) {
    return action.payload
  }
  return previousState
}
